import{jsx as e,jsxs as r}from"react/jsx-runtime";import o from"styled-components";import{BodySecondary as t}from"../../../../TypographyStyle.js";import n from"./IntegerPositiveSingle.js";const i=o.div`
	flex-direction: row;
	display: flex;
	align-items: center;
	gap: 8px;
`,s=o=>{let{val:s,onChange:a,errors:l,disabled:p,connectorType:c}=o;return r(i,{children:[e(n,{disabled:p,val:s,onChange:a,errors:l,connectorType:c}),e(t,{children:"time(s)"})]})};var a=r=>e(s,Object.assign({},r));export{a as default};
